import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './Wrapper.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export var Wrapper = function Wrapper(_ref) {
  var wrap = _ref.wrap,
      children = _ref.children,
      compact = _ref.compact;
  return wrap ? /*#__PURE__*/_jsx("div", {
    className: cc([css.wrap, _defineProperty({}, css.compact, compact)]),
    children: children
  }) : children;
};
Wrapper.propTypes = {
  compact: PropTypes.bool,
  children: PropTypes.any,
  wrap: PropTypes.bool
};
Wrapper.defaultProps = {
  compact: false
};